export const environment = {
  production: true,
  apiUrl: 'https://myprofile-api-prod.remoteapi.ge/myprofileportal/api/',
  siteKey:'0x4AAAAAABpSS6NNES9iDatI'

};
